/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { BasePriceFormatComponent } from './base-price-format.component';
export class PriceFormatComponent extends BasePriceFormatComponent {
}
PriceFormatComponent.decorators = [
    { type: Component, args: [{
                selector: 'price-format',
                template: "<input type=\"tel\" [(ngModel)]=\"_price\" ng-pattern=\"/^[0-9]+(\.[0-9]{1,2})?$/\" [readonly]=\"readonly\" [disabled]=\"disabled\" [ngClass]=\"options.cssclass\" [placeholder]=\"options.placeholder\" (keyup)=\"handleKeyboardKeyUp($event)\" (keydown)=\"handleKeyboardKeyDown($event)\" (focusout)=\"focusOutEvent()\" (focusin)=\"focusInEvent()\" /> ",
                providers: [
                    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => PriceFormatComponent), multi: true },
                    { provide: NG_VALIDATORS, useExisting: forwardRef(() => PriceFormatComponent), multi: true }
                ]
            },] },
];
function PriceFormatComponent_tsickle_Closure_declarations() {
    /** @type {!Array<{type: !Function, args: (undefined|!Array<?>)}>} */
    PriceFormatComponent.decorators;
    /**
     * @nocollapse
     * @type {function(): !Array<(null|{type: ?, decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>)})>}
     */
    PriceFormatComponent.ctorParameters;
}
